import { ammendUiValue, getSplitStaticName } from 'global/common/convert';
import { uniqueKey } from 'global/common/keys';
import { propHelpers } from 'global/common/tester';
import { renderHtml } from 'global/components/html/renderHtml';
import { getThemeColorDirect } from 'global/styles/formatting';
import _ from 'lodash';
import { useCallback, useContext, useRef } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { ElementContext } from '../ElementContext';
import { UiItemContext } from '../UiItemContext';
import { useAppUserAccess } from './useAppUserAccess';
import { ParentContext } from '../ParentContext';

export const useCardElements = () => {

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { eventInfo_state, currentSettings_state } = states
  const { appDataDocuments } = eventInfo_state ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const uiItemContext = useContext(UiItemContext)
  const { item_state, item_handlers } = uiItemContext ?? {}
  const { propGroups, propSections_allowed, viewItem } = item_state ?? {}
  const { handleShow_modifyMapping } = item_handlers ?? {}
  const key_viewItem = viewItem?.key

  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { elemProps } = element_state ?? {}
  const { forAppManagement } = elemProps ?? {}

  const getCardElements = useCallback(({ _keyy, isSubCard, itemData }) => {

    const cardProps = {
      _keyy,
      appDataDocuments,
      appUserSession,
      aps_global,
      aps_viewItem: aps_viewItems && aps_viewItems[key_viewItem],
      forAppManagement,
      itemData,
      propGroups,
      propsSections: propSections_allowed,
      isSubCard,
      handleShow_modifyMapping,
    }

    // const cardElements = groupTaggedPropSectionElements(cardProps)
    const cardElements = group_taggedPropSectionElements(cardProps)
    // console.log('cardElements', cardElements)
    return cardElements
  }, [])

  return { getCardElements }
}

const group_taggedPropSectionElements = (cardProps) => {

  const {
    _keyy,
    appDataDocuments,
    appUserSession,
    aps_global,
    aps_viewItem,
    forAppManagement,
    itemData,
    propGroups,
    propsSections,
    isSubCard,
    handleShow_modifyMapping,
  } = cardProps


  const { imageMapping } = aps_global ?? {}
  const { allowCollectionMapping, locationProps } = imageMapping ?? {}

  const { header, show, tagged } = propGroups ?? {}
  const { props: props_header } = header ?? {}
  const { props: props_show } = show ?? {}
  const { props: props_tagged } = tagged ?? {}

  const nameElements = []
  const metaElements = []

  const _propSections = _.sortBy(propsSections, 'position')

  const item_value = (pv) => {
    if (_.isArray(pv)) {
      const _pv = pv.sort()
      const v = []
      _pv.forEach(pvv => {
        v.push(<div>{pvv}</div>)
      })
      return <div>{v}</div>
    } else {
      return pv
    }
  }

  const item_icon = (icon, iconColor, iconColor_display, allowMapping) => <Icon
    name={allowMapping ? 'map' : icon}
    color={iconColor ? iconColor : null}
    style={{ color: iconColor_display ? iconColor_display : null }}
    onClick={() => { allowMapping && handleShow_modifyMapping && handleShow_modifyMapping() }}
  >
  </Icon>

  /**
   * 
   * @param {object} propItem 
   * @param {number} itemIndex 
   * @param {string} sectionKey 
   */
  const item_element = (propItem, itemIndex, sectionKey) => {

    const { display, key: propKey } = propItem ?? {}
    const { caption, icon, iconColor, defaultIconColor, showAlwaysCaption, useSuffix, suffix } = display ?? {}

    const { props } = aps_viewItem ?? {}
    const prop_viewItem = props && props[propKey]
    const { data } = prop_viewItem ?? {}
    const { staticList } = data ?? {}

    const itemValue = itemData ? itemData[propKey] : null

    let staticViewKey = staticList ? staticList : propKey

    const _allowMapping = allowCollectionMapping && locationProps && locationProps.includes(propKey) ? true : false

    const icon_color = iconColor && iconColor.apply ? iconColor : defaultIconColor

    const _itemValue = ammendUiValue(itemValue, propKey)

    let _icon = icon

    let isGrouped;
    let prop_value;
    let _key = uniqueKey('gspsi', _keyy, itemIndex)
    let _iconColor = _allowMapping ? 'blue' : null;
    let _iconColor_display;

    _iconColor_display = icon_color ? getThemeColorDirect(aps_global, icon_color) : null

    if (!_.isArray(_itemValue) && !_.isObject(_itemValue)) {

      const hasItem = appUserSession && appUserSession[propKey] && appUserSession[propKey].includes(itemValue);

      // this could be an array
      prop_value = getSplitStaticName(appDataDocuments, staticViewKey, _itemValue)

      _iconColor = hasItem ? 'blue' : 'grey'

      if (showAlwaysCaption && (_.isBoolean(prop_value) || prop_value === 'TRUE' || prop_value === 'FALSE' || _.isBoolean(prop_value))) {
        prop_value = caption
        _iconColor = 'green'
      }

      if (useSuffix && suffix) { prop_value += ' ' + suffix }
      prop_value = propHelpers.isHtml(_itemValue) ? renderHtml(_itemValue) : _itemValue
    } else {
      if (_.isArray(_itemValue)) {
        prop_value = getSplitStaticName(appDataDocuments, staticViewKey, _itemValue)
        isGrouped = true
      } else if (_.isObject(_itemValue)) {
        const xxx = []
        _.forEach(_itemValue, (v, key) => {
          xxx.push(<Label color={'green'}>{key}{': '}{v}</Label>)
        })
        prop_value = xxx
      } else {
        prop_value = propHelpers.isHtml(_itemValue) ? renderHtml(_itemValue) : _itemValue
      }
    }

    let pcn;
    if (_icon) {
      pcn = isGrouped ? 'icn-grp' : 'icn-ngrp'
    } else {
      pcn = isGrouped ? 'icn-ngrpp' : ''
      if (_.isArray(prop_value) && _.size(prop_value) > 1) {
        pcn += ' mlt'
      }
    }

    pcn += ' ' + propKey

    let pcnX = 'pcn';
    pcnX += ' ' + propKey

    if (_icon) {
      pcnX += isGrouped ? ' icn-grp' : ' icn-ngrp'
    } else {
      pcnX += isGrouped ? ' icn-ngrpp' : ''
      if (_.isArray(prop_value) && _.size(prop_value) > 1) {
        pcnX += ' mlt'
      }
    }

    if (prop_value) {
      switch (sectionKey) {
        case 'header':
          !isSubCard && nameElements.push(<div key={uniqueKey(_key, 'n')} className={'prc'}>{item_value(prop_value)}</div>)
          break;
        default:
          !isSubCard && metaElements.push(_icon ?
            <div className={pcn}>{<div>{item_icon(_icon, _iconColor, _iconColor_display, _allowMapping)}</div>}{item_value(prop_value)}</div>
            :
            <div className={pcn}>{item_value(prop_value)}</div>)
      }
    }
  }

  let itemIndex = 0

  if (forAppManagement) {
    if (props_show) {
      const ps = _.sortBy(props_show, 'position')
      ps.forEach(propItem => {
        item_element(propItem, itemIndex, 'header')
        itemIndex++
      })
    }
  } else {
    if (props_header && props_header.length > 0) {
      filterName(props_header)
      // filter where name AND firstName and lastName all exist  
      const ph = _.sortBy(props_header, 'position')
      ph.forEach(propItem => {
        item_element(propItem, itemIndex, 'header')
        itemIndex++
      })
    }

    if (props_tagged) {
      const pt = _.sortBy(props_tagged, 'position')
      pt.forEach(propItem => {
        item_element(propItem, itemIndex, 'tagged')
        itemIndex++
      })
    }
  }

  return { nameElements, metaElements, propSections: _propSections }

}

const filterName = (props) => {
  let hasN;
  let nameIndex;
  let hasFn;
  let hasLn;
  props.forEach((propItem, index) => {
    if (propItem.key === 'name') {
      hasN = true
      nameIndex = index
    }
    if (propItem.key === 'firstName') { hasFn = true }
    if (propItem.key === 'lastName') { hasLn = true }
  })
  if (hasN && hasFn && hasLn) {
    props.splice(nameIndex, 1)
  }
}